import { CanDeactivate} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  isBonusOngoing:  boolean;
}

@Injectable()
export class BonusDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): boolean {
    if(component.isBonusOngoing == true){
        if (confirm("You have unsaved changes! If you leave, your changes will be lost..")) {
            return true;
        } 
        else {
            return false;
        }
    }
    if(component.isBonusOngoing == false){
      return true;
    }
  }
}